module.exports = __webpack_public_path__ + "img/home.49d8764c.png";